import { jsx as _jsx } from "react/jsx-runtime";
import { LabeledValue } from "./LabeledValue.js";
export const LabeledSelectMultipleValue = ({ label, value, options, notSetText, ...props }) => {
    const selectedOptions = options.filter(o => value?.includes(o.value));
    return (_jsx(LabeledValue, { label: label, notSet: !selectedOptions.length, ...props, children: selectedOptions.length > 0
            ? selectedOptions.map(o => o.label).join(", ")
            : notSetText }));
};
//# sourceMappingURL=LabeledSelectMultipleValue.js.map